import { BaseConnector } from '@/connectors/base.connector';
import { IIdentity, ISignInCommand } from '@/connectors/identity/identity.model';
import { RequestErrorHandler } from '@/connectors/request-error-handler.model';

export class IdentitiesConnector extends BaseConnector {
  constructor() {
    super('identities');
  }

  async checkAuthentication(): Promise<boolean> {
    try {
      await this.get<void>(`/check-auth`, RequestErrorHandler.None);
      return true;
    } catch (e) {
      return false;
    }
  }

  async refreshToken(refreshToken: string): Promise<IIdentity> {
    return (await this.post<IIdentity>(`/refresh-tokens/${refreshToken}/refresh`, null, RequestErrorHandler.None))
      .result;
  }

  async signIn(signIn: ISignInCommand): Promise<IIdentity> {
    return (await this.post<IIdentity>('/sign-in', signIn, RequestErrorHandler.None)).result;
  }
}
